import { subscriptionPreOrderDeliveryProfileSettingsSchema } from "@redotech/redo-model/checkouts/subscription-pre-order-delivery-profile";
import * as z from "zod";

export const getSubscriptionPreOrderDeliveryProfileSettings = {
  name: "getSubscriptionPreOrderDeliveryProfileSettings" as const,
  input: z.null(),
  output: z.object({
    settings: subscriptionPreOrderDeliveryProfileSettingsSchema.nullable(),
  }),
};
